import React, { useCallback, useEffect, useState } from "react";
import InputDropSearch from "../../../../components/inputs/InputDropSearch";
import baseUrl from "../../../../api/baseUrl";
import StaffRelaseModal from "../components/StaffRelaseModal";
import { useNavigate } from "react-router-dom";

function StaffRelease() {
  const [formData, setformData] = useState<FormData>({
    employeeId: "",
    product: [],
    total: 0,
    netTotal: 0,
    discount: 0,
    card: 0,
    cash: 0,
  });
  const [employees, setEmployees] = useState<Employees[]>([]);
  const [open, setopen] = useState(false);

  
 
  const getEmployeesData = useCallback(async (search: string) => {
    try {
      const response = await baseUrl.get(
        "client/inventory/release/searchAllEmployees",
        {
          headers: {
            keyword: search,
          },
        }
      );
      setEmployees(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }, []);
  useEffect(() => {
    getEmployeesData("");
  }, [getEmployeesData]);
  const handleChange = useCallback((e: any) => {
    const { name, value } = e.target;
    setformData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }, []);
  const searchEmployee = useCallback(
    (e: any) => {
      getEmployeesData(e);
    },
    [getEmployeesData]
  );
  const openModal = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      setopen(true);
    },
    []
  );
  const closeModal = useCallback(() => {
    setopen(false);
  }, []);

  const addProduct = useCallback(
    (product: Product) => {
      setformData((prevFormData) => {
        const updatedProducts = [...prevFormData.product, product];
        const total = updatedProducts.reduce((sum, product) => {
          const price =
            typeof product.total === "string"
              ? parseFloat(product.total)
              : product.total;
          return sum + price;
        }, 0);

        return {
          ...prevFormData,
          product: updatedProducts,
          total: total,
          netTotal: total,
        };
      });
      closeModal();
    },
    [closeModal]
  );
  const removeProductById = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>, id: string) => {
      event.preventDefault();
      setformData((prevFormData) => {
        // Filter out the product by id
        const updatedProducts = prevFormData.product.filter(
          (product: any) => product?.productId !== id
        );

        // Calculate the new total price
        const totalPrice = updatedProducts.reduce((sum, product) => {
          // Convert product.price to a number if it's a string
          const price =
            typeof product.total === "string"
              ? parseFloat(product.total)
              : product.total;
          return sum + price;
        }, 0);

        return {
          ...prevFormData,
          product: updatedProducts,
          total: totalPrice,
          netTotal: totalPrice,
        };
      });
    },
    []
  );
  const navigate = useNavigate()
  const handleSubmit = (e: any) => {
    e.preventDefault();
    baseUrl
      .post("client/inventory/release/employeeProductRelease", formData)
      .then((response) => {
    navigate("/client/inventory/release/all-release")
      })
      .catch((error) => {
        console.error(error?.response);
      });
  };
  return (
    <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
      {open && (
        <StaffRelaseModal addProduct={addProduct} closeModal={closeModal} />
      )}

      {/* Header */}
      <div className="px-3 py-2 border-b border-slate-200 dark:border-slate-600">
        <h3 className="text-xs font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span className="w-7 h-7 bg-amber-100 dark:bg-amber-900/40 rounded-md flex items-center justify-center text-amber-600 dark:text-amber-300 text-xs">👔</span>
          Staff Release
        </h3>
      </div>

      <form onSubmit={handleSubmit} className="p-3 space-y-3">
        <InputDropSearch
          data={employees}
          name="employeeId"
          label="Staff"
          selectName1="firstName"
          selectValue="_id"
          onChange={handleChange}
          onSearch={searchEmployee}
        />

        <button
          type="button"
          onClick={(e: any) => openModal(e)}
          className="w-full px-3 py-2 rounded-lg border-2 border-dashed border-primary/30 dark:border-primary/50 text-primary dark:text-primary font-medium hover:bg-primary/5 dark:hover:bg-primary/10 transition-colors flex items-center justify-center gap-1.5 text-xs"
        >
          <span className="text-base">+</span> Add Product
        </button>

        {formData?.product?.length > 0 && (
          <div className="border border-slate-200 dark:border-slate-600 rounded-lg overflow-hidden">
            <table className="w-full text-xs">
              <thead className="bg-slate-50 dark:bg-slate-700/50">
                <tr>
                  {tableHeader?.map((item: any, i: number) => (
                    <th key={i} className="px-2.5 py-1.5 text-left text-[10px] font-semibold text-slate-500 dark:text-slate-300 uppercase">
                      {item?.title}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-600">
                {formData?.product?.map((item: Product, i: number) => (
                  <tr key={i} className="hover:bg-slate-50 dark:hover:bg-slate-700/50">
                    <td className="px-2.5 py-1.5 text-xs text-slate-500 dark:text-slate-400">{i + 1}</td>
                    <td className="px-2.5 py-1.5 font-medium text-xs text-slate-700 dark:text-slate-200">{item?.productName}</td>
                    <td className="px-2.5 py-1.5 text-xs text-slate-600 dark:text-slate-300">{item?.unitPrice}</td>
                    <td className="px-2.5 py-1.5 text-xs text-slate-600 dark:text-slate-300">{item?.quantity}</td>
                    <td className="px-2.5 py-1.5 text-xs text-slate-600 dark:text-slate-300">{item?.discount}</td>
                    <td className="px-2.5 py-1.5 font-semibold text-xs text-emerald-600 dark:text-emerald-400">{item?.netTotal}</td>
                    <td className="px-2.5 py-1.5">
                      <button
                        type="button"
                        onClick={(e) => removeProductById(e, item?.productId)}
                        className="text-red-500 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 text-[10px] font-medium"
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="p-2.5 bg-emerald-50 dark:bg-emerald-900/40 rounded-lg">
          <p className="text-xs text-emerald-700 dark:text-emerald-300">
            Total: <span className="font-bold text-sm">{formData.total}</span>
          </p>
        </div>

        <button
          type="submit"
          className="w-full px-4 py-2.5 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-semibold hover:shadow-lg hover:shadow-primary/20 transition-all text-xs"
        >
          Submit Release
        </button>
      </form>
    </div>
  );
}

export default StaffRelease;
const tableHeader = [
  {
    title: "No",
  },
  {
    title: "produt Name",
  },
  {
    title: "unit",
  },
  {
    title: "amount",
  },
  {
    title: "discount",
  },
  {
    title: "net total",
  },
  {
    title: "Action",
  },
];
interface Employees {
  _id: string;
  firstName: string;
}
interface Product {
    productId: string;
    unitPrice: number;
    quantity: number;
    total: number;
    discount: number;
    netTotal: number;
  productName: string;
}

interface FormData {
  employeeId: string;
  product: Product[];
  total: number;
  netTotal: number;
  discount: number;
  card: number;
  cash: number;
}
